/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CloudSyncStatus } from '../models';
// @ts-ignore
import type { Database } from '../models';
// @ts-ignore
import type { DatabaseInstance } from '../models';
// @ts-ignore
import type { GetDatabaseInstanceCachingSummaryResponse } from '../models';
// @ts-ignore
import type { GetDatabaseInstanceHealthMetricsResponse } from '../models';
// @ts-ignore
import type { GetDatabaseInstanceMetricsFilterOptionsResponse } from '../models';
// @ts-ignore
import type { GetDatabaseInstanceQueryErrorsResponse } from '../models';
// @ts-ignore
import type { GetDatabaseInstancesCloudIntegrationSummaryResponse } from '../models';
// @ts-ignore
import type { ListCachingPotentialDatabasesResponse } from '../models';
// @ts-ignore
import type { ListCloudOptimizationCandidatesResponse } from '../models';
// @ts-ignore
import type { ListConnectionPoolingCandidatesResponse } from '../models';
// @ts-ignore
import type { ListDatabaseInstanceMembersResponse } from '../models';
// @ts-ignore
import type { ListDatabaseInstancesResponse } from '../models';
// @ts-ignore
import type { ListTopQueryRecommendationsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateDatabaseInstanceRequest } from '../models';
/**
 * DatabaseInstancesAPIApi - axios parameter creator
 * @export
 */
export const DatabaseInstancesAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Register a database for a database instance (idempotent)
         * @summary Register a database for a database instance
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {Database} database 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPICreateDatabase: async (organizationId: string, databaseInstanceId: string, database: Database, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPICreateDatabase', 'organizationId', organizationId)
            // verify required parameter 'databaseInstanceId' is not null or undefined
            assertParamExists('databaseInstancesAPICreateDatabase', 'databaseInstanceId', databaseInstanceId)
            // verify required parameter 'database' is not null or undefined
            assertParamExists('databaseInstancesAPICreateDatabase', 'database', database)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/{databaseInstanceId}/databases`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseInstanceId"}}`, encodeURIComponent(String(databaseInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(database, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a database instance
         * @summary Create a database instance
         * @param {string} organizationId Organization identifier
         * @param {DatabaseInstance} databaseInstance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPICreateDatabaseInstance: async (organizationId: string, databaseInstance: DatabaseInstance, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPICreateDatabaseInstance', 'organizationId', organizationId)
            // verify required parameter 'databaseInstance' is not null or undefined
            assertParamExists('databaseInstancesAPICreateDatabaseInstance', 'databaseInstance', databaseInstance)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(databaseInstance, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a database   Soft-deletes a database.
         * @summary Delete a database
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance id
         * @param {string} id Database identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIDeleteDatabase: async (organizationId: string, databaseInstanceId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIDeleteDatabase', 'organizationId', organizationId)
            // verify required parameter 'databaseInstanceId' is not null or undefined
            assertParamExists('databaseInstancesAPIDeleteDatabase', 'databaseInstanceId', databaseInstanceId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('databaseInstancesAPIDeleteDatabase', 'id', id)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/{databaseInstanceId}/databases/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseInstanceId"}}`, encodeURIComponent(String(databaseInstanceId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a database instance   Soft-deletes a manually created database instance and its associated  databases. Cloud-synced instances cannot be deleted via this API.  Instances with an active proxy deployment must be undeployed first.
         * @summary Delete a database instance
         * @param {string} organizationId Organization identifier
         * @param {string} id Database instance identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIDeleteDatabaseInstance: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIDeleteDatabaseInstance', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('databaseInstancesAPIDeleteDatabaseInstance', 'id', id)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get cloud sync status   Returns the cloud asset sync status for a specific organization,  indicating whether initial cloud sync has completed after onboarding.
         * @summary Get cloud sync status for an organization
         * @param {string} organizationId Organization identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetCloudSyncStatus: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetCloudSyncStatus', 'organizationId', organizationId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/cloud-sync-status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a database by ID   Returns a single database.
         * @summary Get a database by ID
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier.
         * @param {string} id Database identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabase: async (organizationId: string, databaseInstanceId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabase', 'organizationId', organizationId)
            // verify required parameter 'databaseInstanceId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabase', 'databaseInstanceId', databaseInstanceId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabase', 'id', id)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/{databaseInstanceId}/databases/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseInstanceId"}}`, encodeURIComponent(String(databaseInstanceId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get database instance caching summary   Returns per-database caching summaries for a database instance, with  optional filtering by database name and/or username. The caching  summaries are identical to those served by GetDatabaseInstanceDetails,  but this endpoint supports filtering and does not return the additional  instance-level information (cloud details, advisor stats, connections, etc).
         * @summary Get database instance caching summary
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} [startTime] Start of the reporting period. When omitted along with end_time,  defaults to the last 24 hours.
         * @param {string} [endTime] End of the reporting period. When omitted along with start_time,  defaults to now.
         * @param {string} [databaseId] Filter by logical database identifier. When omitted, all databases behind  the proxy are included.
         * @param {string} [username] Filter by username. When omitted, metrics for all users are aggregated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstanceCachingSummary: async (organizationId: string, databaseInstanceId: string, startTime?: string, endTime?: string, databaseId?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstanceCachingSummary', 'organizationId', organizationId)
            // verify required parameter 'databaseInstanceId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstanceCachingSummary', 'databaseInstanceId', databaseInstanceId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/{databaseInstanceId}/caching-summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseInstanceId"}}`, encodeURIComponent(String(databaseInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get database instance details   Returns a database instance including cloud provider info if available,  logical databases with per-database summary statistics and instance-level  summary statistics.
         * @summary Get database instance details
         * @param {string} organizationId Organization identifier
         * @param {string} id Database instance identifier
         * @param {string} [startTime] Start of the period the caching summaries are reported over.  When omitted along with end_time, defaults to the last 24 hours.
         * @param {string} [endTime] End of the period the caching summaries are reported over.  When omitted along with start_time, defaults to the last 24 hours.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstanceDetails: async (organizationId: string, id: string, startTime?: string, endTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstanceDetails', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstanceDetails', 'id', id)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get database instance metrics   Returns aggregated timeseries metrics (avg cpu utilization, avg memory  utilization, avg connections and avg read iops) for a database instance  over the requested period, bucketed by step_seconds.
         * @summary Get database instance metrics
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} [startTime] Start of the period (inclusive)
         * @param {string} [endTime] End of the period (exclusive)
         * @param {number} [stepSeconds] Aggregate items in specified interval steps (in seconds)
         * @param {string} [nodeId] Optional node identifier to filter timeseries for a  specific cluster member. When omitted, all members are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstanceHealthMetrics: async (organizationId: string, databaseInstanceId: string, startTime?: string, endTime?: string, stepSeconds?: number, nodeId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstanceHealthMetrics', 'organizationId', organizationId)
            // verify required parameter 'databaseInstanceId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstanceHealthMetrics', 'databaseInstanceId', databaseInstanceId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/{databaseInstanceId}/health-metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseInstanceId"}}`, encodeURIComponent(String(databaseInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get database instance metrics filter options   Retrieves available filter options (e.g., users) for database instance metrics  using the proxy schema.
         * @summary Get database instance metrics filter options
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} [startTime] Start of the period (inclusive)
         * @param {string} [endTime] End of the period (exclusive)
         * @param {string} [databaseId] Optional database ID to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions: async (organizationId: string, databaseInstanceId: string, startTime?: string, endTime?: string, databaseId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions', 'organizationId', organizationId)
            // verify required parameter 'databaseInstanceId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions', 'databaseInstanceId', databaseInstanceId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/{databaseInstanceId}/metrics-filter-options`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseInstanceId"}}`, encodeURIComponent(String(databaseInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List upstream query errors for a database instance   Returns the upstream query error breakdown for a database instance over  the requested period: totals, per-error-code rows and a bucketed  timeseries of error occurrences per code.
         * @summary List database instance upstream query errors
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} [startTime] Start of the reporting period. When omitted along with end_time,  defaults to the last 24 hours.
         * @param {string} [endTime] End of the reporting period. When omitted along with start_time,  defaults to now.
         * @param {string} [databaseId] Filter by logical database identifier. When omitted, all databases behind  the proxy are included.
         * @param {number} [stepSeconds] Timeseries bucket size in seconds.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstanceQueryErrors: async (organizationId: string, databaseInstanceId: string, startTime?: string, endTime?: string, databaseId?: string, stepSeconds?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstanceQueryErrors', 'organizationId', organizationId)
            // verify required parameter 'databaseInstanceId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstanceQueryErrors', 'databaseInstanceId', databaseInstanceId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/{databaseInstanceId}/query-errors`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseInstanceId"}}`, encodeURIComponent(String(databaseInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (stepSeconds !== undefined) {
                localVarQueryParameter['stepSeconds'] = stepSeconds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get database instances summary for a cloud integration   Returns an aggregated summary across all database instances discovered  via the given cloud integration: the number of instances and the total  queries, max connections and average connections over the last hour.
         * @summary Get database instances cloud integration summary
         * @param {string} organizationId Organization identifier
         * @param {string} cloudIntegrationId Cloud asset integration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary: async (organizationId: string, cloudIntegrationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary', 'organizationId', organizationId)
            // verify required parameter 'cloudIntegrationId' is not null or undefined
            assertParamExists('databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary', 'cloudIntegrationId', cloudIntegrationId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/cloud-integrations/{cloudIntegrationId}/database-instances/summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cloudIntegrationId"}}`, encodeURIComponent(String(cloudIntegrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List top databases by caching potential   Returns the top N logical databases across the organization ranked  by projected hit rate descending. Used by the onboarding flow to  suggest which databases would benefit most from caching.
         * @summary List top databases by caching potential
         * @param {string} organizationId Organization identifier
         * @param {number} [limit] Maximum number of candidates to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListCachingPotentialDatabases: async (organizationId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIListCachingPotentialDatabases', 'organizationId', organizationId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/caching-potential-databases`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List cloud optimization candidates   Returns database instances that are the top candidates for optimization,  ordered by optimization priority descending. Only cloud-synced instances  (those with populated cloud_details) with no features enabled are returned.  Used by the onboarding flow to suggest which databases to optimize first.
         * @summary List cloud optimization candidates
         * @param {string} organizationId Organization identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListCloudOptimizationCandidates: async (organizationId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIListCloudOptimizationCandidates', 'organizationId', organizationId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/cloud-optimization-candidates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List connection pooling optimization candidates   Returns the top N database instances ranked by idle connections  descending. Used by the onboarding flow to suggest which databases  would benefit most from connection pooling.
         * @summary List connection pooling optimization candidates
         * @param {string} organizationId Organization identifier
         * @param {number} [limit] Maximum number of candidates to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListConnectionPoolingCandidates: async (organizationId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIListConnectionPoolingCandidates', 'organizationId', organizationId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/connection-pooling-candidates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List cluster members   Lists the member nodes of a cloud-synced database cluster along with their  configuration and cloud metrics (cpu, memory, average and maximum  connections). Returns an empty list for standalone or manually created  instances.
         * @summary List cluster members of a database instance
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier of the cluster
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListDatabaseInstanceMembers: async (organizationId: string, databaseInstanceId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIListDatabaseInstanceMembers', 'organizationId', organizationId)
            // verify required parameter 'databaseInstanceId' is not null or undefined
            assertParamExists('databaseInstancesAPIListDatabaseInstanceMembers', 'databaseInstanceId', databaseInstanceId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/{databaseInstanceId}/members`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseInstanceId"}}`, encodeURIComponent(String(databaseInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List database instances   Lists database instances for a specific organization
         * @summary List database instances
         * @param {string} organizationId Organization identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListDatabaseInstances: async (organizationId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIListDatabaseInstances', 'organizationId', organizationId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List top query recommendations   Returns the top query (performance) recommendations across the  organization, ordered by impact desc then affected db time desc.  Open query recommendations only; index recommendations are excluded.
         * @summary List top query recommendations
         * @param {string} organizationId Organization identifier
         * @param {number} [limit] Maximum number of recommendations to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListTopQueryRecommendations: async (organizationId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIListTopQueryRecommendations', 'organizationId', organizationId)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/top-query-recommendations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a database instance   Partially updates a manually created database instance. Only the fields  present in the request (name, endpoints) are updated; omitted fields are  left unchanged. Cloud-synced instances cannot be updated via this API.
         * @summary Update a database instance
         * @param {string} organizationId Organization identifier
         * @param {string} id Database instance identifier
         * @param {UpdateDatabaseInstanceRequest} updateDatabaseInstanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIUpdateDatabaseInstance: async (organizationId: string, id: string, updateDatabaseInstanceRequest: UpdateDatabaseInstanceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('databaseInstancesAPIUpdateDatabaseInstance', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('databaseInstancesAPIUpdateDatabaseInstance', 'id', id)
            // verify required parameter 'updateDatabaseInstanceRequest' is not null or undefined
            assertParamExists('databaseInstancesAPIUpdateDatabaseInstance', 'updateDatabaseInstanceRequest', updateDatabaseInstanceRequest)
            const localVarPath = `/database-optimizer/database-instances/v1alpha/organizations/{organizationId}/database-instances/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDatabaseInstanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatabaseInstancesAPIApi - functional programming interface
 * @export
 */
export const DatabaseInstancesAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatabaseInstancesAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Register a database for a database instance (idempotent)
         * @summary Register a database for a database instance
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {Database} database 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPICreateDatabase(organizationId: string, databaseInstanceId: string, database: Database, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Database>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPICreateDatabase(organizationId, databaseInstanceId, database, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPICreateDatabase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a database instance
         * @summary Create a database instance
         * @param {string} organizationId Organization identifier
         * @param {DatabaseInstance} databaseInstance 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPICreateDatabaseInstance(organizationId: string, databaseInstance: DatabaseInstance, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseInstance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPICreateDatabaseInstance(organizationId, databaseInstance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPICreateDatabaseInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a database   Soft-deletes a database.
         * @summary Delete a database
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance id
         * @param {string} id Database identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIDeleteDatabase(organizationId: string, databaseInstanceId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIDeleteDatabase(organizationId, databaseInstanceId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIDeleteDatabase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a database instance   Soft-deletes a manually created database instance and its associated  databases. Cloud-synced instances cannot be deleted via this API.  Instances with an active proxy deployment must be undeployed first.
         * @summary Delete a database instance
         * @param {string} organizationId Organization identifier
         * @param {string} id Database instance identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIDeleteDatabaseInstance(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIDeleteDatabaseInstance(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIDeleteDatabaseInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get cloud sync status   Returns the cloud asset sync status for a specific organization,  indicating whether initial cloud sync has completed after onboarding.
         * @summary Get cloud sync status for an organization
         * @param {string} organizationId Organization identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIGetCloudSyncStatus(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloudSyncStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIGetCloudSyncStatus(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIGetCloudSyncStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a database by ID   Returns a single database.
         * @summary Get a database by ID
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier.
         * @param {string} id Database identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIGetDatabase(organizationId: string, databaseInstanceId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Database>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIGetDatabase(organizationId, databaseInstanceId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIGetDatabase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get database instance caching summary   Returns per-database caching summaries for a database instance, with  optional filtering by database name and/or username. The caching  summaries are identical to those served by GetDatabaseInstanceDetails,  but this endpoint supports filtering and does not return the additional  instance-level information (cloud details, advisor stats, connections, etc).
         * @summary Get database instance caching summary
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} [startTime] Start of the reporting period. When omitted along with end_time,  defaults to the last 24 hours.
         * @param {string} [endTime] End of the reporting period. When omitted along with start_time,  defaults to now.
         * @param {string} [databaseId] Filter by logical database identifier. When omitted, all databases behind  the proxy are included.
         * @param {string} [username] Filter by username. When omitted, metrics for all users are aggregated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIGetDatabaseInstanceCachingSummary(organizationId: string, databaseInstanceId: string, startTime?: string, endTime?: string, databaseId?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDatabaseInstanceCachingSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIGetDatabaseInstanceCachingSummary(organizationId, databaseInstanceId, startTime, endTime, databaseId, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIGetDatabaseInstanceCachingSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get database instance details   Returns a database instance including cloud provider info if available,  logical databases with per-database summary statistics and instance-level  summary statistics.
         * @summary Get database instance details
         * @param {string} organizationId Organization identifier
         * @param {string} id Database instance identifier
         * @param {string} [startTime] Start of the period the caching summaries are reported over.  When omitted along with end_time, defaults to the last 24 hours.
         * @param {string} [endTime] End of the period the caching summaries are reported over.  When omitted along with start_time, defaults to the last 24 hours.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIGetDatabaseInstanceDetails(organizationId: string, id: string, startTime?: string, endTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseInstance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIGetDatabaseInstanceDetails(organizationId, id, startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIGetDatabaseInstanceDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get database instance metrics   Returns aggregated timeseries metrics (avg cpu utilization, avg memory  utilization, avg connections and avg read iops) for a database instance  over the requested period, bucketed by step_seconds.
         * @summary Get database instance metrics
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} [startTime] Start of the period (inclusive)
         * @param {string} [endTime] End of the period (exclusive)
         * @param {number} [stepSeconds] Aggregate items in specified interval steps (in seconds)
         * @param {string} [nodeId] Optional node identifier to filter timeseries for a  specific cluster member. When omitted, all members are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIGetDatabaseInstanceHealthMetrics(organizationId: string, databaseInstanceId: string, startTime?: string, endTime?: string, stepSeconds?: number, nodeId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDatabaseInstanceHealthMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIGetDatabaseInstanceHealthMetrics(organizationId, databaseInstanceId, startTime, endTime, stepSeconds, nodeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIGetDatabaseInstanceHealthMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get database instance metrics filter options   Retrieves available filter options (e.g., users) for database instance metrics  using the proxy schema.
         * @summary Get database instance metrics filter options
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} [startTime] Start of the period (inclusive)
         * @param {string} [endTime] End of the period (exclusive)
         * @param {string} [databaseId] Optional database ID to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions(organizationId: string, databaseInstanceId: string, startTime?: string, endTime?: string, databaseId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDatabaseInstanceMetricsFilterOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions(organizationId, databaseInstanceId, startTime, endTime, databaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List upstream query errors for a database instance   Returns the upstream query error breakdown for a database instance over  the requested period: totals, per-error-code rows and a bucketed  timeseries of error occurrences per code.
         * @summary List database instance upstream query errors
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} [startTime] Start of the reporting period. When omitted along with end_time,  defaults to the last 24 hours.
         * @param {string} [endTime] End of the reporting period. When omitted along with start_time,  defaults to now.
         * @param {string} [databaseId] Filter by logical database identifier. When omitted, all databases behind  the proxy are included.
         * @param {number} [stepSeconds] Timeseries bucket size in seconds.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIGetDatabaseInstanceQueryErrors(organizationId: string, databaseInstanceId: string, startTime?: string, endTime?: string, databaseId?: string, stepSeconds?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDatabaseInstanceQueryErrorsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIGetDatabaseInstanceQueryErrors(organizationId, databaseInstanceId, startTime, endTime, databaseId, stepSeconds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIGetDatabaseInstanceQueryErrors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get database instances summary for a cloud integration   Returns an aggregated summary across all database instances discovered  via the given cloud integration: the number of instances and the total  queries, max connections and average connections over the last hour.
         * @summary Get database instances cloud integration summary
         * @param {string} organizationId Organization identifier
         * @param {string} cloudIntegrationId Cloud asset integration identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary(organizationId: string, cloudIntegrationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDatabaseInstancesCloudIntegrationSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary(organizationId, cloudIntegrationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List top databases by caching potential   Returns the top N logical databases across the organization ranked  by projected hit rate descending. Used by the onboarding flow to  suggest which databases would benefit most from caching.
         * @summary List top databases by caching potential
         * @param {string} organizationId Organization identifier
         * @param {number} [limit] Maximum number of candidates to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIListCachingPotentialDatabases(organizationId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCachingPotentialDatabasesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIListCachingPotentialDatabases(organizationId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIListCachingPotentialDatabases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List cloud optimization candidates   Returns database instances that are the top candidates for optimization,  ordered by optimization priority descending. Only cloud-synced instances  (those with populated cloud_details) with no features enabled are returned.  Used by the onboarding flow to suggest which databases to optimize first.
         * @summary List cloud optimization candidates
         * @param {string} organizationId Organization identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIListCloudOptimizationCandidates(organizationId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCloudOptimizationCandidatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIListCloudOptimizationCandidates(organizationId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIListCloudOptimizationCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List connection pooling optimization candidates   Returns the top N database instances ranked by idle connections  descending. Used by the onboarding flow to suggest which databases  would benefit most from connection pooling.
         * @summary List connection pooling optimization candidates
         * @param {string} organizationId Organization identifier
         * @param {number} [limit] Maximum number of candidates to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIListConnectionPoolingCandidates(organizationId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListConnectionPoolingCandidatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIListConnectionPoolingCandidates(organizationId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIListConnectionPoolingCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List cluster members   Lists the member nodes of a cloud-synced database cluster along with their  configuration and cloud metrics (cpu, memory, average and maximum  connections). Returns an empty list for standalone or manually created  instances.
         * @summary List cluster members of a database instance
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier of the cluster
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIListDatabaseInstanceMembers(organizationId: string, databaseInstanceId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDatabaseInstanceMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIListDatabaseInstanceMembers(organizationId, databaseInstanceId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIListDatabaseInstanceMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List database instances   Lists database instances for a specific organization
         * @summary List database instances
         * @param {string} organizationId Organization identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIListDatabaseInstances(organizationId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDatabaseInstancesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIListDatabaseInstances(organizationId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIListDatabaseInstances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List top query recommendations   Returns the top query (performance) recommendations across the  organization, ordered by impact desc then affected db time desc.  Open query recommendations only; index recommendations are excluded.
         * @summary List top query recommendations
         * @param {string} organizationId Organization identifier
         * @param {number} [limit] Maximum number of recommendations to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIListTopQueryRecommendations(organizationId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTopQueryRecommendationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIListTopQueryRecommendations(organizationId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIListTopQueryRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a database instance   Partially updates a manually created database instance. Only the fields  present in the request (name, endpoints) are updated; omitted fields are  left unchanged. Cloud-synced instances cannot be updated via this API.
         * @summary Update a database instance
         * @param {string} organizationId Organization identifier
         * @param {string} id Database instance identifier
         * @param {UpdateDatabaseInstanceRequest} updateDatabaseInstanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async databaseInstancesAPIUpdateDatabaseInstance(organizationId: string, id: string, updateDatabaseInstanceRequest: UpdateDatabaseInstanceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseInstance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.databaseInstancesAPIUpdateDatabaseInstance(organizationId, id, updateDatabaseInstanceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabaseInstancesAPIApi.databaseInstancesAPIUpdateDatabaseInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DatabaseInstancesAPIApi - factory interface
 * @export
 */
export const DatabaseInstancesAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatabaseInstancesAPIApiFp(configuration)
    return {
        /**
         * Register a database for a database instance (idempotent)
         * @summary Register a database for a database instance
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPICreateDatabase(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<Database> {
            return localVarFp.databaseInstancesAPICreateDatabase(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.database, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a database instance
         * @summary Create a database instance
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseInstanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPICreateDatabaseInstance(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseInstanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<DatabaseInstance> {
            return localVarFp.databaseInstancesAPICreateDatabaseInstance(requestParameters.organizationId, requestParameters.databaseInstance, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a database   Soft-deletes a database.
         * @summary Delete a database
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIDeleteDatabase(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.databaseInstancesAPIDeleteDatabase(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a database instance   Soft-deletes a manually created database instance and its associated  databases. Cloud-synced instances cannot be deleted via this API.  Instances with an active proxy deployment must be undeployed first.
         * @summary Delete a database instance
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseInstanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIDeleteDatabaseInstance(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseInstanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.databaseInstancesAPIDeleteDatabaseInstance(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get cloud sync status   Returns the cloud asset sync status for a specific organization,  indicating whether initial cloud sync has completed after onboarding.
         * @summary Get cloud sync status for an organization
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetCloudSyncStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetCloudSyncStatus(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetCloudSyncStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<CloudSyncStatus> {
            return localVarFp.databaseInstancesAPIGetCloudSyncStatus(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a database by ID   Returns a single database.
         * @summary Get a database by ID
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabase(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<Database> {
            return localVarFp.databaseInstancesAPIGetDatabase(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get database instance caching summary   Returns per-database caching summaries for a database instance, with  optional filtering by database name and/or username. The caching  summaries are identical to those served by GetDatabaseInstanceDetails,  but this endpoint supports filtering and does not return the additional  instance-level information (cloud details, advisor stats, connections, etc).
         * @summary Get database instance caching summary
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstanceCachingSummary(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDatabaseInstanceCachingSummaryResponse> {
            return localVarFp.databaseInstancesAPIGetDatabaseInstanceCachingSummary(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.startTime, requestParameters.endTime, requestParameters.databaseId, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * Get database instance details   Returns a database instance including cloud provider info if available,  logical databases with per-database summary statistics and instance-level  summary statistics.
         * @summary Get database instance details
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstanceDetails(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DatabaseInstance> {
            return localVarFp.databaseInstancesAPIGetDatabaseInstanceDetails(requestParameters.organizationId, requestParameters.id, requestParameters.startTime, requestParameters.endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Get database instance metrics   Returns aggregated timeseries metrics (avg cpu utilization, avg memory  utilization, avg connections and avg read iops) for a database instance  over the requested period, bucketed by step_seconds.
         * @summary Get database instance metrics
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstanceHealthMetrics(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDatabaseInstanceHealthMetricsResponse> {
            return localVarFp.databaseInstancesAPIGetDatabaseInstanceHealthMetrics(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get database instance metrics filter options   Retrieves available filter options (e.g., users) for database instance metrics  using the proxy schema.
         * @summary Get database instance metrics filter options
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceMetricsFilterOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceMetricsFilterOptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDatabaseInstanceMetricsFilterOptionsResponse> {
            return localVarFp.databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.startTime, requestParameters.endTime, requestParameters.databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * List upstream query errors for a database instance   Returns the upstream query error breakdown for a database instance over  the requested period: totals, per-error-code rows and a bucketed  timeseries of error occurrences per code.
         * @summary List database instance upstream query errors
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstanceQueryErrors(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrorsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDatabaseInstanceQueryErrorsResponse> {
            return localVarFp.databaseInstancesAPIGetDatabaseInstanceQueryErrors(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.startTime, requestParameters.endTime, requestParameters.databaseId, requestParameters.stepSeconds, options).then((request) => request(axios, basePath));
        },
        /**
         * Get database instances summary for a cloud integration   Returns an aggregated summary across all database instances discovered  via the given cloud integration: the number of instances and the total  queries, max connections and average connections over the last hour.
         * @summary Get database instances cloud integration summary
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDatabaseInstancesCloudIntegrationSummaryResponse> {
            return localVarFp.databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary(requestParameters.organizationId, requestParameters.cloudIntegrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * List top databases by caching potential   Returns the top N logical databases across the organization ranked  by projected hit rate descending. Used by the onboarding flow to  suggest which databases would benefit most from caching.
         * @summary List top databases by caching potential
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListCachingPotentialDatabasesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListCachingPotentialDatabases(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListCachingPotentialDatabasesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCachingPotentialDatabasesResponse> {
            return localVarFp.databaseInstancesAPIListCachingPotentialDatabases(requestParameters.organizationId, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * List cloud optimization candidates   Returns database instances that are the top candidates for optimization,  ordered by optimization priority descending. Only cloud-synced instances  (those with populated cloud_details) with no features enabled are returned.  Used by the onboarding flow to suggest which databases to optimize first.
         * @summary List cloud optimization candidates
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListCloudOptimizationCandidatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListCloudOptimizationCandidates(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListCloudOptimizationCandidatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCloudOptimizationCandidatesResponse> {
            return localVarFp.databaseInstancesAPIListCloudOptimizationCandidates(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List connection pooling optimization candidates   Returns the top N database instances ranked by idle connections  descending. Used by the onboarding flow to suggest which databases  would benefit most from connection pooling.
         * @summary List connection pooling optimization candidates
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListConnectionPoolingCandidatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListConnectionPoolingCandidates(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListConnectionPoolingCandidatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListConnectionPoolingCandidatesResponse> {
            return localVarFp.databaseInstancesAPIListConnectionPoolingCandidates(requestParameters.organizationId, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * List cluster members   Lists the member nodes of a cloud-synced database cluster along with their  configuration and cloud metrics (cpu, memory, average and maximum  connections). Returns an empty list for standalone or manually created  instances.
         * @summary List cluster members of a database instance
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstanceMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListDatabaseInstanceMembers(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstanceMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDatabaseInstanceMembersResponse> {
            return localVarFp.databaseInstancesAPIListDatabaseInstanceMembers(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List database instances   Lists database instances for a specific organization
         * @summary List database instances
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstancesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListDatabaseInstances(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstancesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDatabaseInstancesResponse> {
            return localVarFp.databaseInstancesAPIListDatabaseInstances(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List top query recommendations   Returns the top query (performance) recommendations across the  organization, ordered by impact desc then affected db time desc.  Open query recommendations only; index recommendations are excluded.
         * @summary List top query recommendations
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListTopQueryRecommendationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIListTopQueryRecommendations(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListTopQueryRecommendationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTopQueryRecommendationsResponse> {
            return localVarFp.databaseInstancesAPIListTopQueryRecommendations(requestParameters.organizationId, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a database instance   Partially updates a manually created database instance. Only the fields  present in the request (name, endpoints) are updated; omitted fields are  left unchanged. Cloud-synced instances cannot be updated via this API.
         * @summary Update a database instance
         * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIUpdateDatabaseInstanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        databaseInstancesAPIUpdateDatabaseInstance(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIUpdateDatabaseInstanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<DatabaseInstance> {
            return localVarFp.databaseInstancesAPIUpdateDatabaseInstance(requestParameters.organizationId, requestParameters.id, requestParameters.updateDatabaseInstanceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for databaseInstancesAPICreateDatabase operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabase
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabase
     */
    readonly databaseInstanceId: string

    /**
     * 
     * @type {Database}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabase
     */
    readonly database: Database
}

/**
 * Request parameters for databaseInstancesAPICreateDatabaseInstance operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseInstanceRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseInstanceRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseInstance
     */
    readonly organizationId: string

    /**
     * 
     * @type {DatabaseInstance}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseInstance
     */
    readonly databaseInstance: DatabaseInstance
}

/**
 * Request parameters for databaseInstancesAPIDeleteDatabase operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabase
     */
    readonly organizationId: string

    /**
     * Database instance id
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabase
     */
    readonly databaseInstanceId: string

    /**
     * Database identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabase
     */
    readonly id: string
}

/**
 * Request parameters for databaseInstancesAPIDeleteDatabaseInstance operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseInstanceRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseInstanceRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseInstance
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseInstance
     */
    readonly id: string
}

/**
 * Request parameters for databaseInstancesAPIGetCloudSyncStatus operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetCloudSyncStatusRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetCloudSyncStatusRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetCloudSyncStatus
     */
    readonly organizationId: string
}

/**
 * Request parameters for databaseInstancesAPIGetDatabase operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabase
     */
    readonly organizationId: string

    /**
     * Database instance identifier.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabase
     */
    readonly databaseInstanceId: string

    /**
     * Database identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabase
     */
    readonly id: string
}

/**
 * Request parameters for databaseInstancesAPIGetDatabaseInstanceCachingSummary operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummaryRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummaryRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummary
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummary
     */
    readonly databaseInstanceId: string

    /**
     * Start of the reporting period. When omitted along with end_time,  defaults to the last 24 hours.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummary
     */
    readonly startTime?: string

    /**
     * End of the reporting period. When omitted along with start_time,  defaults to now.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummary
     */
    readonly endTime?: string

    /**
     * Filter by logical database identifier. When omitted, all databases behind  the proxy are included.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummary
     */
    readonly databaseId?: string

    /**
     * Filter by username. When omitted, metrics for all users are aggregated.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummary
     */
    readonly username?: string
}

/**
 * Request parameters for databaseInstancesAPIGetDatabaseInstanceDetails operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceDetailsRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceDetailsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceDetails
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceDetails
     */
    readonly id: string

    /**
     * Start of the period the caching summaries are reported over.  When omitted along with end_time, defaults to the last 24 hours.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceDetails
     */
    readonly startTime?: string

    /**
     * End of the period the caching summaries are reported over.  When omitted along with start_time, defaults to the last 24 hours.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceDetails
     */
    readonly endTime?: string
}

/**
 * Request parameters for databaseInstancesAPIGetDatabaseInstanceHealthMetrics operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetricsRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetricsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetrics
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetrics
     */
    readonly databaseInstanceId: string

    /**
     * Start of the period (inclusive)
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetrics
     */
    readonly startTime?: string

    /**
     * End of the period (exclusive)
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetrics
     */
    readonly endTime?: string

    /**
     * Aggregate items in specified interval steps (in seconds)
     * @type {number}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetrics
     */
    readonly stepSeconds?: number

    /**
     * Optional node identifier to filter timeseries for a  specific cluster member. When omitted, all members are returned.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetrics
     */
    readonly nodeId?: string
}

/**
 * Request parameters for databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceMetricsFilterOptionsRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceMetricsFilterOptionsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions
     */
    readonly databaseInstanceId: string

    /**
     * Start of the period (inclusive)
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions
     */
    readonly startTime?: string

    /**
     * End of the period (exclusive)
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions
     */
    readonly endTime?: string

    /**
     * Optional database ID to filter by
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions
     */
    readonly databaseId?: string
}

/**
 * Request parameters for databaseInstancesAPIGetDatabaseInstanceQueryErrors operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrorsRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrorsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrors
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrors
     */
    readonly databaseInstanceId: string

    /**
     * Start of the reporting period. When omitted along with end_time,  defaults to the last 24 hours.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrors
     */
    readonly startTime?: string

    /**
     * End of the reporting period. When omitted along with start_time,  defaults to now.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrors
     */
    readonly endTime?: string

    /**
     * Filter by logical database identifier. When omitted, all databases behind  the proxy are included.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrors
     */
    readonly databaseId?: string

    /**
     * Timeseries bucket size in seconds.
     * @type {number}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrors
     */
    readonly stepSeconds?: number
}

/**
 * Request parameters for databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummaryRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummaryRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary
     */
    readonly organizationId: string

    /**
     * Cloud asset integration identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary
     */
    readonly cloudIntegrationId: string
}

/**
 * Request parameters for databaseInstancesAPIListCachingPotentialDatabases operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIListCachingPotentialDatabasesRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIListCachingPotentialDatabasesRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListCachingPotentialDatabases
     */
    readonly organizationId: string

    /**
     * Maximum number of candidates to return
     * @type {number}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListCachingPotentialDatabases
     */
    readonly limit?: number
}

/**
 * Request parameters for databaseInstancesAPIListCloudOptimizationCandidates operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIListCloudOptimizationCandidatesRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIListCloudOptimizationCandidatesRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListCloudOptimizationCandidates
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListCloudOptimizationCandidates
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListCloudOptimizationCandidates
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for databaseInstancesAPIListConnectionPoolingCandidates operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIListConnectionPoolingCandidatesRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIListConnectionPoolingCandidatesRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListConnectionPoolingCandidates
     */
    readonly organizationId: string

    /**
     * Maximum number of candidates to return.
     * @type {number}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListConnectionPoolingCandidates
     */
    readonly limit?: number
}

/**
 * Request parameters for databaseInstancesAPIListDatabaseInstanceMembers operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstanceMembersRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstanceMembersRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstanceMembers
     */
    readonly organizationId: string

    /**
     * Database instance identifier of the cluster
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstanceMembers
     */
    readonly databaseInstanceId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstanceMembers
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstanceMembers
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for databaseInstancesAPIListDatabaseInstances operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstancesRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstancesRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstances
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstances
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstances
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for databaseInstancesAPIListTopQueryRecommendations operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIListTopQueryRecommendationsRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIListTopQueryRecommendationsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListTopQueryRecommendations
     */
    readonly organizationId: string

    /**
     * Maximum number of recommendations to return.
     * @type {number}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIListTopQueryRecommendations
     */
    readonly limit?: number
}

/**
 * Request parameters for databaseInstancesAPIUpdateDatabaseInstance operation in DatabaseInstancesAPIApi.
 * @export
 * @interface DatabaseInstancesAPIApiDatabaseInstancesAPIUpdateDatabaseInstanceRequest
 */
export interface DatabaseInstancesAPIApiDatabaseInstancesAPIUpdateDatabaseInstanceRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIUpdateDatabaseInstance
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIUpdateDatabaseInstance
     */
    readonly id: string

    /**
     * 
     * @type {UpdateDatabaseInstanceRequest}
     * @memberof DatabaseInstancesAPIApiDatabaseInstancesAPIUpdateDatabaseInstance
     */
    readonly updateDatabaseInstanceRequest: UpdateDatabaseInstanceRequest
}

/**
 * DatabaseInstancesAPIApi - object-oriented interface
 * @export
 * @class DatabaseInstancesAPIApi
 * @extends {BaseAPI}
 */
export class DatabaseInstancesAPIApi extends BaseAPI {
    /**
     * Register a database for a database instance (idempotent)
     * @summary Register a database for a database instance
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPICreateDatabase(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPICreateDatabase(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.database, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a database instance
     * @summary Create a database instance
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseInstanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPICreateDatabaseInstance(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPICreateDatabaseInstanceRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPICreateDatabaseInstance(requestParameters.organizationId, requestParameters.databaseInstance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a database   Soft-deletes a database.
     * @summary Delete a database
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIDeleteDatabase(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIDeleteDatabase(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a database instance   Soft-deletes a manually created database instance and its associated  databases. Cloud-synced instances cannot be deleted via this API.  Instances with an active proxy deployment must be undeployed first.
     * @summary Delete a database instance
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseInstanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIDeleteDatabaseInstance(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIDeleteDatabaseInstanceRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIDeleteDatabaseInstance(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get cloud sync status   Returns the cloud asset sync status for a specific organization,  indicating whether initial cloud sync has completed after onboarding.
     * @summary Get cloud sync status for an organization
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetCloudSyncStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIGetCloudSyncStatus(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetCloudSyncStatusRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIGetCloudSyncStatus(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a database by ID   Returns a single database.
     * @summary Get a database by ID
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIGetDatabase(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIGetDatabase(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get database instance caching summary   Returns per-database caching summaries for a database instance, with  optional filtering by database name and/or username. The caching  summaries are identical to those served by GetDatabaseInstanceDetails,  but this endpoint supports filtering and does not return the additional  instance-level information (cloud details, advisor stats, connections, etc).
     * @summary Get database instance caching summary
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIGetDatabaseInstanceCachingSummary(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceCachingSummaryRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIGetDatabaseInstanceCachingSummary(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.startTime, requestParameters.endTime, requestParameters.databaseId, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get database instance details   Returns a database instance including cloud provider info if available,  logical databases with per-database summary statistics and instance-level  summary statistics.
     * @summary Get database instance details
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIGetDatabaseInstanceDetails(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceDetailsRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIGetDatabaseInstanceDetails(requestParameters.organizationId, requestParameters.id, requestParameters.startTime, requestParameters.endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get database instance metrics   Returns aggregated timeseries metrics (avg cpu utilization, avg memory  utilization, avg connections and avg read iops) for a database instance  over the requested period, bucketed by step_seconds.
     * @summary Get database instance metrics
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIGetDatabaseInstanceHealthMetrics(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceHealthMetricsRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIGetDatabaseInstanceHealthMetrics(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.startTime, requestParameters.endTime, requestParameters.stepSeconds, requestParameters.nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get database instance metrics filter options   Retrieves available filter options (e.g., users) for database instance metrics  using the proxy schema.
     * @summary Get database instance metrics filter options
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceMetricsFilterOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceMetricsFilterOptionsRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIGetDatabaseInstanceMetricsFilterOptions(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.startTime, requestParameters.endTime, requestParameters.databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List upstream query errors for a database instance   Returns the upstream query error breakdown for a database instance over  the requested period: totals, per-error-code rows and a bucketed  timeseries of error occurrences per code.
     * @summary List database instance upstream query errors
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIGetDatabaseInstanceQueryErrors(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstanceQueryErrorsRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIGetDatabaseInstanceQueryErrors(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.startTime, requestParameters.endTime, requestParameters.databaseId, requestParameters.stepSeconds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get database instances summary for a cloud integration   Returns an aggregated summary across all database instances discovered  via the given cloud integration: the number of instances and the total  queries, max connections and average connections over the last hour.
     * @summary Get database instances cloud integration summary
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummaryRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIGetDatabaseInstancesCloudIntegrationSummary(requestParameters.organizationId, requestParameters.cloudIntegrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List top databases by caching potential   Returns the top N logical databases across the organization ranked  by projected hit rate descending. Used by the onboarding flow to  suggest which databases would benefit most from caching.
     * @summary List top databases by caching potential
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListCachingPotentialDatabasesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIListCachingPotentialDatabases(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListCachingPotentialDatabasesRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIListCachingPotentialDatabases(requestParameters.organizationId, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List cloud optimization candidates   Returns database instances that are the top candidates for optimization,  ordered by optimization priority descending. Only cloud-synced instances  (those with populated cloud_details) with no features enabled are returned.  Used by the onboarding flow to suggest which databases to optimize first.
     * @summary List cloud optimization candidates
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListCloudOptimizationCandidatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIListCloudOptimizationCandidates(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListCloudOptimizationCandidatesRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIListCloudOptimizationCandidates(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List connection pooling optimization candidates   Returns the top N database instances ranked by idle connections  descending. Used by the onboarding flow to suggest which databases  would benefit most from connection pooling.
     * @summary List connection pooling optimization candidates
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListConnectionPoolingCandidatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIListConnectionPoolingCandidates(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListConnectionPoolingCandidatesRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIListConnectionPoolingCandidates(requestParameters.organizationId, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List cluster members   Lists the member nodes of a cloud-synced database cluster along with their  configuration and cloud metrics (cpu, memory, average and maximum  connections). Returns an empty list for standalone or manually created  instances.
     * @summary List cluster members of a database instance
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstanceMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIListDatabaseInstanceMembers(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstanceMembersRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIListDatabaseInstanceMembers(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List database instances   Lists database instances for a specific organization
     * @summary List database instances
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstancesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIListDatabaseInstances(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListDatabaseInstancesRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIListDatabaseInstances(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List top query recommendations   Returns the top query (performance) recommendations across the  organization, ordered by impact desc then affected db time desc.  Open query recommendations only; index recommendations are excluded.
     * @summary List top query recommendations
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIListTopQueryRecommendationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIListTopQueryRecommendations(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIListTopQueryRecommendationsRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIListTopQueryRecommendations(requestParameters.organizationId, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a database instance   Partially updates a manually created database instance. Only the fields  present in the request (name, endpoints) are updated; omitted fields are  left unchanged. Cloud-synced instances cannot be updated via this API.
     * @summary Update a database instance
     * @param {DatabaseInstancesAPIApiDatabaseInstancesAPIUpdateDatabaseInstanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseInstancesAPIApi
     */
    public databaseInstancesAPIUpdateDatabaseInstance(requestParameters: DatabaseInstancesAPIApiDatabaseInstancesAPIUpdateDatabaseInstanceRequest, options?: RawAxiosRequestConfig) {
        return DatabaseInstancesAPIApiFp(this.configuration).databaseInstancesAPIUpdateDatabaseInstance(requestParameters.organizationId, requestParameters.id, requestParameters.updateDatabaseInstanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

